// Flow types automatically removed

import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import { FormattedMessage } from 'dibs-react-intl';
import getter from 'dibs-object-getter';
import classnames from 'classnames';
import { Link } from 'dibs-elements/exports/Link.tsx';
import styles from './styles/InteriorsLandingProjectItem.scss';

const profileUrl = urlLabel => {
    return `/design-firms/${urlLabel}/`;
};

function InteriorsLandingProjectItemComponent({ projectModule, type }) {
    const projectImageUrl = getter(projectModule).value('imageUrl');
    const projectId = getter(projectModule).at('project').value('serviceId');
    const projectUrl = getter(projectModule).at('project').value('url');
    const projectName = getter(projectModule).at('project').value('name') || '';
    const designerId = getter(projectModule).at('designFirm').value('serviceId');
    const designerName = getter(projectModule).at('designFirm').value('name');
    const designerUrl = getter(projectModule)
        .at('designFirm')
        .at('publicProfile')
        .value('urlLabel');
    const designerImage = getter(projectModule)
        .at('designFirm')
        .at('directoryProfile')
        .value('profilePhoto');

    if (!projectImageUrl || !projectUrl) {
        return null;
    }

    let colClasses = '';

    if (type === 'primary') {
        colClasses = 'colXs12 colLg12';
    } else if (type === 'secondary') {
        colClasses = 'colXs12 colLg6';
    } else if (type === 'tertiary') {
        colClasses = 'colXs6 colLg3';
    }

    const projectClasses = classnames(styles.projectItem, styles[type], colClasses);
    const designerNameTn = `designer-name-${designerId}`;
    const designerLink = designerUrl ? (
        <Link
            className={styles.projectCreatorLink}
            dataTn={designerNameTn}
            href={profileUrl(designerUrl)}
        >
            {designerName}
        </Link>
    ) : (
        <span data-tn={designerNameTn}>{designerName}</span>
    );
    return (
        <div className={projectClasses} data-tn={`interiors-landing-${type}-project-tile`}>
            <div className={styles.projectImageWrapper}>
                <Link href={projectUrl}>
                    <div
                        className={styles.projectImage}
                        title={projectName}
                        alt={projectName}
                        style={{
                            backgroundImage: `url(${projectImageUrl})`,
                        }}
                        data-tn={`project-image-${projectId}`}
                    />
                </Link>
            </div>
            <div className={styles.projectDetails}>
                {designerImage && designerUrl && (
                    <Link href={profileUrl(designerUrl)}>
                        <div
                            className={styles.projectCreatorImageWrapper}
                            style={{
                                backgroundImage: `url(${designerImage})`,
                            }}
                            title={designerName}
                            alt={designerName}
                            data-tn={`designer-image-${designerId}`}
                        />
                    </Link>
                )}

                <div className="colXsCenter">
                    <div className={styles.projectName}>
                        <Link href={projectUrl} dataTn={`project-name-${projectId}`}>
                            {projectName}
                        </Link>
                    </div>
                    <div className={styles.projectCreator}>
                        <FormattedMessage
                            id="abt.InteriorsLanding.projectItemDesigner"
                            defaultMessage="by {designerLink}"
                            values={{
                                designerLink,
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
export const InteriorsLandingProjectItem = createFragmentContainer(
    InteriorsLandingProjectItemComponent,
    {
        projectModule: graphql`
            fragment InteriorsLandingProjectItem_projectModule on InteriorsLandingModuleItem {
                project {
                    serviceId
                    name
                    url
                }
                designFirm {
                    serviceId
                    name
                    directoryProfile {
                        profilePhoto
                    }
                    publicProfile {
                        urlLabel
                    }
                }
                imageUrl
            }
        `,
    }
);
